import { render } from "./eBooksCard.vue?vue&type=template&id=fcd79114"
import script from "./eBooksCard.vue?vue&type=script&lang=js"
export * from "./eBooksCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__